import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '../../constants/api-endpoints.config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  private apiEndPoint: any = ApiEndpoints;
  url: string = environment.apiurls.baseUrl;

  constructor(private apiService: ApiService) { }

  /**
   * This function is used to get user list.
   * @returns 
   */
  getUserList(): Observable<any> {
    return this.apiService.get(`${this.url}${this.apiEndPoint.userManagement.getProfiles}`);
  }

  /**
   * Get user list with pagination
   */
  getUserListPaginated(pageNo: number, pageSize: number, status?: string): Observable<any> {
    const statusParam = status ? `&status=${encodeURIComponent(status)}` : '';
    return this.apiService.get(
      `${this.url}${this.apiEndPoint.userManagement.getProfiles}?pageNo=${pageNo}&pageSize=${pageSize}${statusParam}`
    );
  }

  /**
   * This function is used to get list by search query.
   * @param query
   * @returns
   */
  getUserListBySearchQuery(query: any) {
    return this.apiService.get(`${this.url}${this.apiEndPoint.userManagement.getListSearchQuery}${query}`);
  }

  /**
   * Search users with pagination
   */
  getUserListBySearchQueryPaginated(query: string, pageNo: number, pageSize: number, status?: string) {
    const q = encodeURIComponent(query || '');
    const statusParam = status ? `&status=${encodeURIComponent(status)}` : '';
    return this.apiService.get(
      `${this.url}${this.apiEndPoint.userManagement.getProfiles}?search=${q}&pageNo=${pageNo}&pageSize=${pageSize}${statusParam}`
    );
  }

  /**
   * This function is used to change status of user.
   * @param itemId 
   * @param status 
   * @returns 
   */
  changeUserStatusById(itemId: any, status: any) {
    return this.apiService.put(`${this.url}${this.apiEndPoint.userManagement.updateProfileStatus}${itemId}`, status);
  }

  /**
   * This function is used to delete a user by id.
   * @param itemId
   * @returns
   */
  deleteUserById(itemId: any): Observable<any> {
    return this.apiService.delete(`${this.url}${this.apiEndPoint.userManagement.deleteUser}${itemId}`);
  }

}
